export const hasLostStatus = (status:any[]) => {
    return status?.some((item: any) => item.type === 'closed_lost')
}

export const hasWonStatus = (status:any[]) => {
    return status?.some((item: any) => item.type === 'closed_won')
}
